import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.653 0c.52 4.541 3.013 7.249 7.347 7.537v5.108c-2.512.25-4.712-.586-7.272-2.16v9.552c0 12.136-13.013 15.928-18.245 7.23-3.362-5.598-1.303-15.42 9.481-15.813v5.386c-.821.134-1.7.346-2.502.624-2.399.826-3.759 2.372-3.381 5.098.727 5.223 10.152 6.769 9.368-3.437V.01h5.204V0Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }